import { h } from "harmaja"
import { icon16 } from "./icons16"

// 16x16 stroke icons from the design handoff; colored via currentColor
export const Icon16 = ({ name }: { name: keyof typeof icon16 & string }) => (
    <span
        className="icon16"
        ref={(el: HTMLElement) => {
            el.innerHTML = icon16[name] ?? ""
        }}
    />
)
